// TODO: BSummers update the callbacks to handle multiple calls better.

// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var featurePlayers = [];
var heroPlayer;
var featureVid;
var $ = jQuery;
var shouldResizeVideo = false;
var heroVideoPlayer = $('.hero-video-player');


function onYouTubeIframeAPIReady() { // eslint-disable-line no-unused-vars
  'use strict';

  var heroVid = $('.hero-video-player:not(.processed)');
  if (typeof heroVid !== 'undefined' && heroVid.length) {
    heroVid.addClass('processed').each(function () {
      $(this).parent().addClass('hero-video-container');
      var vid = $(this).data('vid');
      var heroVidButton = $(this).parent().siblings('.js-hero-video-player-button');
      if (vid) {
        shouldResizeVideo = true;
        heroPlayer = new YT.Player('player-' + vid, { // eslint-disable-line no-undef
          videoId: vid,
          playerVars: {
            rel: 0, autoplay: 1, controls: 0, loop: 1, playlist: vid, showinfo: 0, modestbranding: 1, wmode: 'opaque', mute: 1, fs: 0
          },
          events: {
            onReady: onPlayerReady
          }
        });
        heroVideoResize();

        if (heroVidButton.length > 0) {
          heroVidButton.on('click', function () {
            var videoPaused = $(this).attr('aria-pressed');
            if (videoPaused === 'true') {
              heroPlayer.playVideo();
              $(this).attr('aria-pressed', false).text('Pause Autoplay');
            }
            else {
              heroPlayer.pauseVideo();
              $(this).attr('aria-pressed', true).text('Resume Video');
            }
          });
        }
      }
    });
  }

  if ($('.featured-video-player').length) {
    featureVid = $('.featured-video-player:not(.processed)');
  }
  if (typeof featureVid !== 'undefined' && featureVid.length) {
    featureVid.addClass('processed').each(function () {
      var vid = $(this).data('vid');
      if (vid) {
        featurePlayers[vid] = new YT.Player('player-' + vid, { // eslint-disable-line no-undef
          videoId: vid,
          playerVars: {
            rel: 0, autoplay: 0, controls: 1, loop: 0, showinfo: 0, modestbranding: 0, wmode: 'opaque'
          }
        });
      }
    });
  }
}

if (window.playerReady) { onYouTubeIframeAPIReady(); } // eslint-disable-line no-undef

function heroVideoResize() {
  'use strict';
  var w = $(window).width() + 200;
  var h = $(window).height() + 200;

  if (w / h > 16 / 9) {
    heroPlayer.setSize(w, w / 16 * 9);
    $(heroVideoPlayer).css({left: '0px'});
  }
  else {
    heroPlayer.setSize(h / 9 * 16, h);
    $(heroVideoPlayer).css({left: -($(heroVideoPlayer).outerWidth() - w) / 2});
  }
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady() {
  'use strict';
  heroPlayer.mute();
}

// Get player by vid; load first if not specified.
function getPlayer(vid) {
  'use strict';
  if (typeof vid === 'undefined' || featurePlayers.hasOwnProperty(vid) === false) {
    return featurePlayers[Object.keys(featurePlayers)[0]];
  }
  else {
    return featurePlayers[vid];
  }
}

// Used to play player on play btn click
function playPlayer(vid) { // eslint-disable-line no-unused-vars
  'use strict';
  onYouTubeIframeAPIReady();
  getPlayer(vid).playVideo();
}

// Used to pause player on modal close
function pausePlayer() { // eslint-disable-line no-unused-vars
  'use strict';
  if ($('.featured-video-player.processed').length || $('.component-kr-modal-video--video-player').length || $('.kr-process-video--video-player').length) {
    for (var key in featurePlayers) {
      if (featurePlayers.hasOwnProperty(key)) {
        featurePlayers[key].pauseVideo();
      }
    }
  }
}

$(window).on('resize', function () {
  'use strict';
  if (shouldResizeVideo === true) {
    heroVideoResize();
  }
});
